import { render } from "./NoProviderReference.vue?vue&type=template&id=7ba4309b&scoped=true&ts=true"
import script from "./NoProviderReference.vue?vue&type=script&lang=ts"
export * from "./NoProviderReference.vue?vue&type=script&lang=ts"

import "./NoProviderReference.vue?vue&type=style&index=0&id=7ba4309b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ba4309b"]])

export default __exports__